<template>
  <div style="
    width: 100%; 
    min-height: 436px;
    max-height: 436px; 
    position: relative;
    transform-origin: top left; 
    overflow: hidden;
    pointer-events: none;
    background: #f5f5f5;
  ">
    
    <!-- Sidebar -->
    <div class="sideBar">
      
      <!-- Logo and Menu Button -->
      <div class="mb-1" style="display: flex; align-items: center;">
        <img :src="logo || logoRemovebg" alt="Logo" style="width: 50px; margin-left: 10px; height: 25px; object-fit: contain; font-size: 10px;" />
        <v-icon size="12" style="margin-left: auto;">mdi-menu</v-icon>
      </div>

      <!-- User Profile -->
      <div style="display: flex; align-items: center; padding: 6px; background: #FDB8B820; border-radius: 8px; margin-bottom: 16px;">
        <v-avatar color="#55555540" size="20">
          <v-icon size="12">mdi-account</v-icon>
        </v-avatar>
        <div style="margin-left: 5px; flex: 1; flex-direction: column;" class="d-flex">
          <div style="font-size: 7px; font-weight: 500; color: rgba(0,0,0,0.87);">Admin Fusion Solution</div>
          <div style="font-size: 4px; padding: 2px 8px; background: linear-gradient(90deg, #F67760 0%, #9C1F21 100%); color: white; border-radius: 12px; width: 42px;">Super Admin</div>
        </div>
      </div>

      <!-- Menu Items -->
      <div>
        <div v-for="(item, index) in menuItems" :key="index" style="margin-bottom: 4px;">
          <div 
            :class="{ 'active-menu': item.active }"
            :style="{
              padding: '6px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              background: 'transparent',
              color: item.active ? 'white' : 'inherit'
            }">
            <img :src="item.icon" alt="icon" width="10" height="10" style="margin-right: 12px;" :style="{filter: item.active ? 'brightness(0) invert(1)' : ''}"/>
            <span style="font-size: 7px; font-weight: 500;">{{ item.title }}</span>
            <span v-if="item.unreadCount > 0" class="menu-unread-badge">{{ item.unreadCount }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Header -->
    <div class="header" style="
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 8px;
      background-color: #f5f5f5;"
      :style="headerBg ? `background-image: url(${headerBg}); background-size: cover; background-position: center;` : ''">
      
      <div style="flex: 1;">
        <h1 style="font-size: 10px; font-weight: 500; margin: 0;" :style="`color: ${headerColor}`">
          User Management
        </h1>
        <div style="display: flex; align-items: center; margin-top: 2px; font-size: 6px;">
          <span>User Management</span>
          <v-icon size="8">mdi-slash-forward</v-icon>
          <span>Portal User Management</span>
        </div>
      </div>

      <div style="display: flex; align-items: center; gap: 8px;">
        <label
          style="
            font-size: 6px;
            color: #C32E0E;
            border-radius: 8px;
            padding: 2px 6px;
            background: linear-gradient(-84deg, #F6776010 0%, #C32E0E10 35%, #F6776010 93%);
          ">
          Version R2.3.0
        </label>
        <div 
          style="width: 15px; height: 15px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 6px; color: white;"
          :style="`background: #${buttonColor}`">
          EN
        </div>
        <div 
          style="padding: 2px 8px; border-radius: 16px; display: flex; align-items: center; color: white;"
          >
          <v-icon size="10" color="black">mdi-account</v-icon>
          <span class="ml-1" style="font-size: 6px; font-weight: 600;" :style="`color: ${headerColor}`">User</span>
          <v-icon size="8" color="black" style="margin-top: -1px;">mdi-chevron-down</v-icon>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="main-content" style="
      margin-top: 0;
      padding: 5px 10px;
    ">

      <div style="background: white; border-radius: 8px;" class="border">
        <div 
          style="display: flex; border-radius: 8px 8px 0 0; justify-content: space-between; padding: 6px; align-items: center;"
          :style="titleBg ? `background-image: url(${titleBg}); background-size: cover; background-position: center;` : ''"
        >
          <h2 style="font-size: 10px; font-weight: 600; margin: 0;" :style="`color: ${titleColor} !important;`">Portal User Management</h2>
          <div class="action-controls flex-wrap">
            <!-- Template Button -->
            <v-btn
              id="button-downloadtemplate-usermanagement"
              color="info"
              class="control-btn template-btn"
              variant="text" 
              size="small"
              density="comfortable"
              :style="`border: 1px solid ${buttonColor}; color: ${buttonColor} !important;`"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                :style="{ color: buttonColor }"
              >
                <path
                  d="M11.7992 14.6659V3.19922M20.3992 14.6659V18.4881C20.3992 18.995 20.1979 19.4811 19.8395 19.8395C19.4811 20.1979 18.995 20.3992 18.4881 20.3992H5.11033C4.60347 20.3992 4.11737 20.1979 3.75897 19.8395C3.40057 19.4811 3.19922 18.995 3.19922 18.4881V14.6659"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.02344 9.88867L11.8012 14.6664L16.579 9.88867"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="btn-text">{{ $t("template") }}</span>
            </v-btn>

            <!-- Import Button -->
            <v-btn
              id="button-importtemplate-usermanagement"
              color="info"
              class="control-btn import-btn"
              variant="text"
              size="small"
              density="comfortable"
              :style="`border: 1px solid ${buttonColor}; color: ${buttonColor} !important;`"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                :style="{ color: buttonColor }"
              >
                <path
                  d="M15.5 2.5V6.5C15.5 6.76522 15.6054 7.01957 15.7929 7.20711C15.9804 7.39464 16.2348 7.5 16.5 7.5H20.5"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.5 12.5V4.5C6.5 3.96957 6.71071 3.46086 7.08579 3.08579C7.46086 2.71071 7.96957 2.5 8.5 2.5H15.5L20.5 7.5V18.5C20.5 19.0304 20.2893 19.5391 19.9142 19.9142C19.5391 20.2893 19.0304 20.5 18.5 20.5H13M3.5 18.5H10.5M10.5 18.5L7.5 15.5M10.5 18.5L7.5 21.5"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <span class="btn-text">{{ $t("import") }}</span>
            </v-btn>

            <!-- Hidden File Component -->
            <DragDropFile
              ref="fileUploader"
              :dialog="true"
              :DragDrop="false"
              :ShowListFile="false"
              :accept="accept"
              @filesUploaded="processUpload($event)"
              :allowType="[]"
              class="d-none"
            />

            <!-- Add User Button -->
            <v-btn
              id="button-add-usermanagement"
              color="primary"
              class="control-btn create-btn"
              variant="elevated"
              size="large"
              rounded="xl"
              :style="`background: ${buttonColor} !important;`"
            >
              <img src="@/assets/Icons/new_round_plus.svg" width="13" height="13" alt="">
              <span class="btn-text">{{ $t("add") }}</span>
              <v-tooltip activator="parent" location="top">
                {{ $t("addNewUser") }}
              </v-tooltip>
            </v-btn>
          </div>
        </div>
        <div class="px-1">
          <v-row class="border px-1" style="border-radius: 8px; margin: 8px 0;">
            <v-col cols="9">
              <v-row >
                <v-col cols="5" class="px-1">
                  <v-text-field
                    id="username-field-search-userchatmanagement"
                    class="userNameInput"
                    :placeholder="$t('username')"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    color="primary"
                  >
                    <template #prepend-inner>
                      <img 
                        src="@/assets/Icons/new_search_outline.svg" 
                        alt="search" 
                        style="width:12px;height:12px;"
                      />
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="5" class="px-1">
                  <v-text-field
                    id="email-field-search-userchatmanagement"
                    class="emailInput"
                    :placeholder="$t('email')"
                    density="comfortable"
                    variant="outlined"
                    hide-details
                    color="primary"
                  >
                    <template #prepend-inner>
                      <img 
                        src="@/assets/Icons/new_search_outline.svg" 
                        alt="search" 
                        style="width:12px;height:12px;"
                      />
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="1"
                  class="d-flex align-center px-1"
                >
                  <v-btn
                    color="primary"
                    class="rounded-circle pa-0"
                    style="
                      min-width: 20px !important; 
                      max-width: 20px !important; 
                      height: 20px;
                      background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%);
                    "
                    :style="`background: ${buttonColor} !important;`"
                    variant="elevated"
                  >
                    <img src="@/assets/Icons/new_search_bold.svg" width="12" height="12" alt="">
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" lg="1" class="d-none d-lg-flex justify-center px-0">
              <v-divider
                vertical
                thickness="2"
                length="20"
                style="background: #C32E0E;"
              ></v-divider>
            </v-col>
            <v-col cols="2" class="d-flex justify-center align-center px-0">
              <img 
                src="@/assets/Icons/new_filter.png" 
                alt="filter"
                width="10"
                height="10"
              />
              <span class="btn-text ml-1" :style="`color: #${buttonColor};`" style="text-transform: none !important;">Filter</span>
            </v-col>
          </v-row>
          <v-data-table-server
            :items="dammyItems"
            :items-per-page="10"
            :items-length="5"
            :headers="headers"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.number }}</td>
                <td>{{ item.username }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.mobile }}</td>
                <td>{{ item.fullName }}</td>
                <td>{{ item.role }}</td>
                <td style="text-align: center; max-width: 60px;">
                  <div class="d-flex" style="justify-content: center; min-width: 60px !important; max-width: 60px !important;">
                    <v-btn
                      id="button-edit-popupedit-userchatmanagement"
                      variant="text"
                      density="comfortable"
                      class="action-btn"
                      icon
                    >
                      <img src="@/assets/Icons/new_edit.svg" width="9" height="9" alt="">
                    </v-btn>
                    <v-btn
                      id="button-delete-popupdelete-userchatmanagement"
                      variant="text"
                      density="comfortable"
                      class="action-btn"
                      icon
                    >
                      <img src="@/assets/Icons/new_delete.svg" width="9" height="9" alt="">
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
            <template v-slot:bottom>
              <div
                class="d-flex justify-space-between align-center"
                style="width: 100%; margin-top: 5px;"
              >
                <div style="font-size: 7px;">{{ $t("totalResults") }} 5</div>

                <v-data-table-footer
                  :items="[
                    { text: '10', value: 10 },
                    { text: '25', value: 25 },
                    { text: '50', value: 50 },
                    { text: '100', value: 100 },
                    { text: 'All', value: -1 },
                  ]"
                  style="font-size: 7px;"
                  class="pa-0"
                  page="1"
                  :length="Math.ceil(5 / 10)"
                />
              </div>
            </template>
          </v-data-table-server>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logoRemovebg from "@/assets/images/logo-removebg-preview@3x.png";
import DashboardIcon from "@/assets/Icons/icon-dashboard.svg";
import ModelCreateIcon from "@/assets/Icons/icon-model-create.svg";
import KManageIcon from "@/assets/Icons/icon-knowledge.svg";
import FlowIcon from "@/assets/Icons/icon-flow.svg";
import UserManageIcon from "@/assets/Icons/icon-user-manage.svg";
import SettingIcon from "@/assets/Icons/icon-setting.svg";
import IntentIcon from "@/assets/Icons/icon-intent.svg";
import OptiTechIcon from "@/assets/Icons/icon-optimization.svg";
import ModelTestIcon from "@/assets/Icons/icon-model-test.svg";
import ChatManageIcon from "@/assets/Icons/icon-chat-manage.svg";
import ReportIcon from "@/assets/Icons/icon-report.svg";
import LogsIcon from "@/assets/Icons/icon-logs.svg";
import ChatPlayIcon from "@/assets/Icons/icon-chat-playground.svg";
import DualChatPlayIcon from "@/assets/Icons/icon-dual-chat-playground.svg";
import ChatServiceIcon from "@/assets/Icons/icon-chat-service.svg";

export default {
  name: "ServiceThemePreview",
  inject: ["tabSocialType"],
  props: {
    logo: {
      type: String,
      default: ""
    },
    buttonColor: {
      type: String,
      default: "#C32E0E"
    },
    headerColor: {
      type: String,
      default: "#000000"
    },
    headerBg: {
      type: String,
      default: ""
    },
    titleColor: {
      type: String,
      default: ""
    },
    titleBg: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      logoRemovebg,
      baseMenuItems: [
        { title: "Dashboard", icon: DashboardIcon, active: false },
        { title: "Model Creator", icon: ModelCreateIcon, active: false },
        { title: "Knowledge Management", icon: KManageIcon, active: false },
        { title: "Flow", icon: FlowIcon, active: false },
        { title: "Intent", icon: IntentIcon, active: false },
        { title: "Optimization Template", icon: OptiTechIcon, active: false },
        { title: "Model Testing", icon: ModelTestIcon, active: false },
        { title: "User Management", icon: UserManageIcon, active: true },
        { title: "Chat Management", icon: ChatManageIcon, active: false },
        { title: "Setting", icon: SettingIcon, active: false },
        { title: "Reports", icon: ReportIcon, active: false },
        { title: "Logs", icon: LogsIcon, active: false },
        { title: "Chat Playground", icon: ChatPlayIcon, active: false },
        { title: "Dual Chat Playground", icon: DualChatPlayIcon, active: false },
        { title: "Chat Service", icon: ChatServiceIcon, active: false, isChatService: true }
      ],
      dammyItems: [
        { number: 1, username: "john_doe", email: "YhVx6@example.com", mobile: "1234567890", fullName: "John Doe", role: "Super Admin" },
        { number: 2, username: "jane_smith", email: "6Hw0g@example.com", mobile: "9876543210", fullName: "Jane Smith", role: "Admin" },
        { number: 3, username: "alice_jones", email: "6Hw0g@example.com", mobile: "9876543210", fullName: "Alice Jones", role: "User" },
        { number: 4, username: "bob_brown", email: "6Hw0g@example.com", mobile: "9876543210", fullName: "Bob Brown", role: "Operator" },
        { number: 5, username: "charlie_black", email: "6Hw0g@example.com", mobile: "9876543210", fullName: "Charlie Black", role: "User" }
      ],
      headers: [
        {
          title: "No.",
          align: "center",
          sortable: false,
        },
        {
          title: "Username",
          align: "start",
          sortable: false,
          value: "username",
        },
        {
          title: "Email",
          align: "start",
          sortable: false,
          value: "email",
        },
        {
          title: "Phone Number",
          align: "start",
          sortable: false,
          value: "mobile",
        },
        { title: "Name", align: "start", sortable: false, value: "fullName" },
        { title: "Role", align: "start", sortable: false, value: "role" },
        {
          title: "Manage",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    chatServiceUnreadCount() {
      const providedTabs = this.tabSocialType && typeof this.tabSocialType === 'object' && 'value' in this.tabSocialType
        ? this.tabSocialType.value
        : this.tabSocialType;
      const socialTabs = Array.isArray(providedTabs) ? providedTabs : [];
      const allTab = socialTabs.find(item => item.value === 'All');
      const normalizedCount = Number(allTab?.unreadCount ?? 0);

      return Number.isFinite(normalizedCount) ? normalizedCount : 0;
    },
    menuItems() {
      return this.baseMenuItems.map(item =>
        item.isChatService
          ? { ...item, unreadCount: this.chatServiceUnreadCount }
          : item
      );
    },
  },
};
</script>

<style scoped>
.sideBar {
  width: 150px;
  min-height: 436px;
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(to bottom, #ffffff, #ffffff, #FFF5F2, #FFF5F2);
  border-right: 1px solid #e0e0e0;
  overflow-y: auto;
  padding: 6px;
}
.header {
  margin-left: 150px;
}
.main-content {
  margin-left: 150px;
}

.active-menu {
  background: linear-gradient(90deg,
      #C32E0E 0%,
      #F67760 100%) !important;
}
.action-controls {
  display: flex;
  align-items: center;
  padding: 0px !important;
  gap: 4px;
  background: transparent;
}
.control-btn {
  font-weight: 500;
  border-radius: 8px !important;
  /* background-color: white !important; */
}
.template-btn,
.import-btn {
  display: flex;
  width: 75px;
  height: 20px;
  font-size: 10px;
  margin: 0px !important;
  padding: 11px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.create-btn {
  display: flex;
  height: 20px !important;
  padding: 11px 8px;
  margin: 0px !important;
  justify-content: center;
  font-size: 18px !important;
  box-shadow: none !important;
  align-items: center;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%);
  color: white;
  min-width: 50px !important;
}
.btn-text {
  text-transform: none;
  font-size: 8px;
} 
.menu-unread-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 12px;
  height: 12px;
  margin-left: auto;
  padding: 0 4px;
  border-radius: 999px;
  background: #C30000;
  color: #fff;
  font-size: 7px;
  font-weight: 600;
  line-height: 1;
}
.userNameInput :deep(.v-input__control .v-field),
.emailInput :deep(.v-input__control .v-field) {
  border-radius: 8px !important;
  background-color: white !important;
  display: flex;
  padding: 6px !important;
  align-items: center;
  height: 40px !important;
  gap: 2px;
  flex: 1 0 0;
  align-self: stretch;
  height: 20px !important;
}
.userNameInput :deep(.v-field__input),
.emailInput :deep(.v-field__input) {
  padding: 0 !important;
  font-size: 8px;
}

::v-deep .v-data-table__wrapper {
  margin-bottom: 0;
}
.v-table :deep(.v-data-table__thead > tr > th) {
  min-height: 30px !important;
  max-height: 30px !important;
}
.v-table :deep(.v-data-table__th) {
  border-bottom: none !important;
  padding: 0 4px;
  font-size: 8px !important;
  height: 30px !important;
}
.v-table :deep(.v-data-table__thead tr th:first-child) {
  border-radius: 8px 0 0 0 !important;
  background: #FFF2F2;     /* header radius */
}
.v-table :deep(.v-data-table__thead tr th:last-child) {
  border-radius: 0 8px 0 0 !important;
  background: #FFF2F2;     /* header radius */
}
.v-table :deep(.v-data-table__thead tr th:not(:first-child):not(:last-child)) {
  border-radius: 0 0 0 0 !important;
  background: #FFF2F2;     /* header radius */
}
.v-table :deep(.v-data-table-header__content span) {
  font-weight: 600 !important;
}
.v-table :deep(.v-data-table__tbody tr td){
  border-bottom: 1px solid #E1E1E1 !important;
  font-size: 7px !important;
  padding: 0 6px !important;
  height: 30px !important;
}
.v-table :deep(.v-data-table__tbody tr):hover {
  background: #FFFCFC;
}
.v-table :deep(.v-data-table-footer__items-per-page .v-input) {
  width: 35px !important;
  height: 18px !important;
}
.v-table :deep(.v-data-table-footer__items-per-page .v-input__control) {
  height: 18px !important;
  width: 35px !important;
}
.v-table :deep(.v-data-table-footer__items-per-page .v-field) {
  font-size: 7px !important;
  min-height: 18px !important;
  max-height: 18px !important;
  height: 18px !important;
  min-width: 35px !important;
  max-width: 35px !important;
  width: 35px !important;
  padding-right: 4px !important;
}
.v-table :deep(.v-data-table-footer__items-per-page .v-field__field) {
  height: 18px !important;
}
.v-table :deep(.v-data-table-footer__items-per-page .v-field__field .v-field__input) {
  min-height: 18px !important;
  max-height: 18px !important;
  height: 18px !important;
  padding: 0 0 0 8px;
}
.v-table :deep(.v-data-table-footer__pagination .v-pagination__list li button) {
  width: 20px !important;
  min-height: 18px !important;
  max-height: 18px !important;
  height: 18px !important;
}
.v-table :deep(.v-data-table-footer__pagination .v-btn__content) {
  font-size: 8px !important;
}

.action-btn {
  width: 15px !important;
  height: 15px !important;
  min-width: 15px !important;
}

@media (max-width: 1200px) {
  .sideBar {
    width: 120px;
  }
  .header {
    margin-left: 120px;
  }
  .main-content {
    margin-left: 120px;
  }
  .template-btn,
  .import-btn {
    width: 30px !important;
    font-size: 5px !important;
    padding: 0px !important;
  }
  .create-btn {
    font-size: 5px !important;
    padding: 0px !important;
  }
  .btn-text {
    font-size: 5px !important;
  }
  .template-btn img,
  .import-btn img,
  .create-btn img {
    width: 8px !important;
    height: 8px !important;
  }
  .control-btn{
    padding: 0px !important;
  }
}
</style>
